// extracted by mini-css-extract-plugin
export default {"downloadNotification":"style_downloadNotification__Vzude"};